var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.26 8.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.16,6.91c-.66-.84-3.2-2.6-3.07-3.03.15-.47,1.03-1.09,1.35-1.45.35-.39,1.32-1.43,1.21-1.98-.2-.95-1.67-.15-2.03.15-.16.13-1.86,1.85-1.85,1.88-.86-.74-1.63-1.6-2.3-1.87C.45.19,0,.8.27,1.73c.12.41.94.88,1.26,1.15.26.21,1.29.73,1.3,1.12,0,.37-2.98,1.59-2.83,3.08,1.33,1.73,3.76-1.48,4-1.48.27,0,1.38,1.31,1.5,1.47.39.51,1.06,1.49,1.71,1.28.45-.15,1.34-.93.93-1.44Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.9a0863d40a3128e9c08f40694111727f.svg";
export { ForwardRef as ReactComponent };